export default __webpack_public_path__ + "static/media/1.a05ae51f.png";